import React from 'react';
import * as MUIcon from '@mui/icons-material';
import SvgColor from 'src/minimal-components/svg-color';
interface IconProps {
  iconName: React.ReactElement;
  color?: string;
  sx?: any;
}
const ICONS: {[key: string]: React.ReactElement} = {
  // Your icons mapping...
  dashboard: (
    <SvgColor
      src={`/assets/icons/navbar/ic_newdash.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  // Add other icons as needed...
  ecommerce: (
    <SvgColor
      src={`/assets/icons/navbar/ic_ecommerce.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  analytics: (
    <SvgColor
      src={`/assets/icons/navbar/ic_analytics.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  archive: (
    <SvgColor
      src={`/assets/icons/navbar/ic_archive.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  projectplan: (
    <SvgColor
      src={`/assets/icons/navbar/ic_projectplan.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  forecast: (
    <SvgColor
      src={`/assets/icons/navbar/ic_forecast.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  department: (
    <SvgColor
      src={`/assets/icons/navbar/ic_department.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  applications: (
    <SvgColor
      src={`/assets/icons/navbar/ic_applications.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  security: (
    <SvgColor
      src={`/assets/icons/navbar/ic_security.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  quality: (
    <SvgColor
      src={`/assets/icons/navbar/ic_quality.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  fixedasset: (
    <SvgColor
      src={`/assets/icons/navbar/ic_fixedassets.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  finaicial: (
    <SvgColor
      src={`/assets/icons/navbar/ic_fanancials.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  project: (
    <SvgColor
      src={`/assets/icons/navbar/ic_project.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  services: (
    <SvgColor
      src={`/assets/icons/navbar/ic_services.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  vendors: (
    <SvgColor
      src={`/assets/icons/navbar/ic_vendors.svg`}
      sx={{width: 1, height: 1}}
    />
  ),
  transfusion: (
    <SvgColor
      src={`/assets/icons/navbar/transfusion.svg`}
      sx={{width: 1, height: 1}}
    />
  )
};
const isCustomIcon = (name: string): boolean => {
  return Object.keys(ICONS).includes(name);
};
const IconComponent = (props: IconProps): React.ReactElement => {
  const {iconName, color, sx} = props;
  // @ts-ignore
  if (isCustomIcon(iconName)) {
    // Custom SVG or another special icon
    // @ts-ignore
    return ICONS[iconName];
  }
  // Attempt to use a Material-UI icon
  // @ts-ignore
  const Icon = MUIcon?.[iconName];
  return <Icon sx={sx} color={color} />;
};

export default IconComponent;
